<!-- Buy Now Popup -->
<div *ngIf="isOpen" class="buy-now-popup fixed inset-0 z-50" (click)="onBackdropClick($event)">
  <!-- Backdrop overlay -->
  <div class="absolute inset-0 bg-black bg-opacity-50"></div>

  <!-- Popup content -->
  <div
    class="absolute top-0 right-0 h-full w-full max-w-[400px] sm:w-[90vw] md:w-[400px] transition-transform ease-in-out duration-300 transform z-50"
    [class.translate-x-full]="!isOpen" [class.translate-x-0]="isOpen" (click)="$event.stopPropagation()">
    <section
      class="flex flex-col bg-white h-full max-h-screen shadow-xl w-full max-w-[400px] sm:w-[90vw] md:w-[400px] text-[15px] leading-6 text-neutral-800">
      <!-- Scrollable Content Area -->
      <div class="flex-1 overflow-y-auto">
        <!-- Header -->
        <header class="flex justify-between items-center px-4 sm:px-6 py-3 sm:py-4 border-b">
          <h1 class="text-xl sm:text-2xl font-bold text-[#0A0A5F] tracking-normal">
            Book Now
          </h1>
          <button type="button" class="p-1 border-0 bg-transparent text-[#0A0A5F]" (click)="closePopup()"
            aria-label="Close">
            <svg class="w-6 h-6 sm:w-7 sm:h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </header>

        <!-- Delivery/Pickup Options -->
        <!-- <div class="flex flex-row gap-3 px-4 sm:px-6 pt-4 pb-2">
          <button *ngIf="productData?.part_type !== 'Scrap Part'" type="button" (click)="selectDeliveryOption('home')"
            [class.bg-blue-50]="selectedDeliveryOption === 'home'"
            [class.border-[#0A0A5F]]="selectedDeliveryOption === 'home'"
            [class.text-[#0A0A5F]]="selectedDeliveryOption === 'home'"
            [class.border-gray-300]="selectedDeliveryOption !== 'home'"
            [class.text-gray-700]="selectedDeliveryOption !== 'home'"
            class="flex-1 flex items-center gap-2 px-3 py-3 border rounded-lg text-left">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6">
              </path>
            </svg>
            <span class="flex flex-col min-w-0">
              <span class="text-sm font-bold leading-5">Home Delivery</span>
              <span class="text-xs font-normal text-gray-500 leading-4">Get Delivery by 24th Feb</span>
            </span>
          </button>
          <button type="button" [disabled]="productData?.part_type === 'Scrap Part'"
            (click)="selectDeliveryOption('store')" [class.bg-blue-50]="
              selectedDeliveryOption === 'store' ||
              productData?.part_type === 'Scrap Part'
            " [class.border-[#0A0A5F]]="
              selectedDeliveryOption === 'store' ||
              productData?.part_type === 'Scrap Part'
            " [class.text-[#0A0A5F]]="
              selectedDeliveryOption === 'store' ||
              productData?.part_type === 'Scrap Part'
            " [class.border-gray-300]="
              selectedDeliveryOption !== 'store' &&
              productData?.part_type !== 'Scrap Part'
            " [class.text-gray-700]="
              selectedDeliveryOption !== 'store' &&
              productData?.part_type !== 'Scrap Part'
            " class="flex-1 flex items-center gap-2 px-3 py-3 border rounded-lg text-left">
            <svg class="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4">
              </path>
            </svg>
            <span class="flex flex-col min-w-0">
              <span class="text-sm font-bold leading-5">Store Pickup</span>
              <span class="text-xs font-normal text-gray-500 leading-4">Pickup after 24th Feb</span>
            </span>
          </button>
        </div> -->

        <!-- Address Section (Product Detail Style) -->

        <div class="flex flex-col gap-3 px-4 sm:px-6 pt-4">
          <!-- For Scrap Part: Only show store pickup info -->
          <ng-container *ngIf="productData?.part_type === 'Scrap Part'">
            <div class="bg-[#F5F9FE] rounded-lg p-3">
              <div class="text-sm font-bold text-[#0A0A5F] leading-5">
                Store Pickup: {{ productData?.seller_name | slice: 0 : 15 }}
              </div>
              <address class="mt-2 text-sm leading-5 text-neutral-500 not-italic">
                {{ productData?.seller_address_1 }}
                <ng-container *ngIf="productData?.seller_address_2">, {{ productData?.seller_address_2 }}</ng-container>
                <ng-container *ngIf="productData?.seller_address_3">, {{ productData?.seller_address_3 }}</ng-container>
              </address>
              <p class="mt-2 text-[13px] leading-5 text-gray-800">
                Note - Pickup between 9:00 am to 6:00 pm
              </p>
            </div>
          </ng-container>

          <ng-container *ngIf="productData?.part_type !== 'Scrap Part'">
            <!-- Deliver Block -->
            <div class="bg-[#F5F9FE] rounded-lg p-3" *ngIf="
                selectedDeliveryOption === 'home' &&
                hasAddress(userData?.shipping_address)
              ">
              <div class="flex items-start justify-between gap-2 mb-1">
                <div class="text-sm font-bold text-[#0A0A5F] leading-5 min-w-0">
                  Deliver:
                  {{
                  userData?.shipping_address?.receiver_name
                  ? userData?.shipping_address?.receiver_name
                  : userData?.shipping_address?.company_name
                  ? userData?.shipping_address?.company_name
                  : (userData.first_name + " " + userData.last_name
                  | slice: 0 : 15)
                  }}
                </div>
                <div class="flex items-center gap-2 shrink-0">
                  <span
                    class="bg-white text-xs px-2 py-0.5 rounded-full font-medium text-neutral-500 border border-zinc-300"
                    *ngIf="userData?.shipping_address?.address_type">{{
                    userData?.shipping_address?.address_type | titlecase
                    }}</span>
                  <button class="px-2 py-1 text-[#0A0A5F] border border-[#0A0A5F] rounded-md text-xs font-bold"
                    (click)="openAddressSelection('shipping')">
                    Change
                  </button>
                </div>
              </div>
              <div class="text-sm leading-5 text-neutral-500" *ngIf="userData?.shipping_address">
                {{ formatAddress(userData?.shipping_address) }}
              </div>
              <div class="text-sm leading-5 text-gray-500" *ngIf="!userData?.shipping_address">
                No delivery address selected
              </div>
              <div *ngIf="
                  userData?.billing_address?.id !==
                  userData?.shipping_address?.id
                " class="text-[13px] leading-5 text-gray-800 mt-2">
                Note - Delivery details and billing details will be different
              </div>
            </div>
            <div class="bg-[#F5F9FE] rounded-lg p-3" *ngIf="
                selectedDeliveryOption === 'store' &&
                productData?.part_type !== 'Scrap Part'
              ">
              <div class="text-sm font-bold text-[#0A0A5F] leading-5">
                Store Pickup: {{ (productData?.seller_name || productData?.seller_detail?.seller_name ||
                productData?.seller_detail?.branch_name) | slice: 0 : 25 }}
              </div>
              <p class="mt-2 text-[13px] leading-5 text-gray-800">
                Note - Pickup between 9:00 am to 6:00 pm
              </p>
            </div>

            <div *ngIf="
                selectedDeliveryOption === 'home' &&
                !hasAddress(userData?.shipping_address) &&
                !hasAddress(userData?.billing_address)
              " class="bg-[#F5F9FE] rounded-lg px-3 py-3">
              <div class="flex items-center justify-between gap-3">
                <span class="text-sm font-bold text-[#0A0A5F] leading-5">
                  Add address to check for delivery & services
                </span>
                <button
                  class="shrink-0 px-3 py-1.5 text-xs font-bold text-[#0A0A5F] border border-[#0A0A5F] rounded-md hover:bg-blue-50"
                  (click)="openAddressSelection('shipping')">
                  Add address
                </button>
              </div>
            </div>
          </ng-container>

          <!-- Billing Block (home delivery + scrap store pickup) -->
          <div class="bg-[#F5F9FE] rounded-lg p-3" *ngIf="shouldShowBillingBlock()">
            <div class="flex items-start justify-between gap-2 mb-1">
              <div class="text-sm font-bold text-[#0A0A5F] leading-5 min-w-0">
                Billing: {{ getBillingDisplayName() | slice: 0 : 15 }}
              </div>
              <div class="flex items-center gap-2 shrink-0">
                <span
                  class="bg-white text-xs px-2 py-0.5 rounded-full font-medium text-neutral-500 border border-zinc-300"
                  *ngIf="getBillingAddressType()">{{ getBillingAddressType() | titlecase }}</span>
                <button class="px-2 py-1 text-[#0A0A5F] border border-[#0A0A5F] rounded-md text-xs font-bold"
                  (click)="onBillingChangeClick()">
                  Change
                </button>
              </div>
            </div>
            <div class="text-sm leading-5 text-neutral-500">{{ billingAddress }}</div>
            <div class="text-[13px] leading-5 text-gray-800 mt-2" *ngIf="billingGST !== 'No GSTIN'">
              GST: {{ billingGST }}
            </div>
          </div>

          <!-- Scrap: prompt to add billing when none saved -->
          <div *ngIf="
              isScrapPart() &&
              !hasAddress(userData?.billing_address) &&
              !hasAddress(userData?.shipping_address)
            " class="bg-[#F5F9FE] rounded-lg px-3 py-3">
            <div class="flex items-center justify-between gap-3">
              <span class="text-sm font-bold text-[#0A0A5F] leading-5">
                Add billing address for invoice & pickup
              </span>
              <button
                class="shrink-0 px-3 py-1.5 text-xs font-bold text-[#0A0A5F] border border-[#0A0A5F] rounded-md hover:bg-blue-50"
                (click)="openAddressSelection('billing')">
                Add address
              </button>
            </div>
          </div>
        </div>

        <!-- Billing Options Section (Radio Buttons) -->
        <div class="px-4 sm:px-6 pt-4">
          <div class="flex flex-wrap gap-x-4 gap-y-2 items-center">
            <label class="flex items-center gap-2 text-sm font-bold text-black leading-5">
              <input type="radio" name="billingOption" value="Billing" [checked]="selectedBillingOption === 'Billing'"
                (change)="onBillingOptionChange('Billing')" class="w-4 h-4 accent-[#0A0A5F]" />
              Add different Billing details
            </label>
            <label *ngIf="canAddGstDetails" class="flex items-center gap-2 text-sm font-bold text-black leading-5">
              <input type="radio" name="billingOption" value="gstin" [checked]="selectedBillingOption === 'gstin'"
                (change)="onBillingOptionChange('gstin')" class="w-4 h-4 accent-[#0A0A5F]" />
              Add GSTIN
            </label>
          </div>
        </div>

        <!-- Product Section -->
        <div class="flex flex-row gap-3 px-4 sm:px-6 pt-4">
          <div class="relative shrink-0">
            <img [src]="getProductImage()" class="w-[120px] h-[120px] rounded-lg object-cover" alt="Product" />
            <!-- Grade Badge -->
            <div *ngIf="productData?.quality_s" [ngClass]="
                productData?.quality_s === 'A'
                  ? 'bg-green-100 text-green-800'
                  : productData?.quality_s === 'B'
                    ? 'bg-yellow-100 text-yellow-800'
                    : productData?.quality_s === 'C'
                      ? 'bg-orange-100 text-orange-800'
                      : 'bg-green-100 text-green-800'
              " class="absolute top-2 left-2 z-10 flex items-center px-2 py-1 rounded shadow font-bold text-xs">
              <svg width="20" height="20" class="mr-1">
                <rect width="20" height="20" rx="4" [attr.fill]="
                    productData?.quality_s === 'A'
                      ? '#01811D'
                      : productData?.quality_s === 'B'
                        ? '#B8860B'
                        : productData?.quality_s === 'C'
                          ? '#D35400'
                          : '#01811D'
                  " />
                <text x="10" y="15" text-anchor="middle" font-size="12" font-family="Arial, sans-serif" fill="white">
                  {{ productData.quality_s }}
                </text>
              </svg>
              Quality
            </div>
          </div>
          <div class="flex-1 min-w-0">
            <div class="font-bold text-sm leading-5 text-black line-clamp-2">
              {{ getProductDescription() }}
            </div>
            <div class="text-[13px] leading-5 text-gray-500 mt-1">
              {{ getProductDetails() }}
            </div>
            <div class="flex items-center gap-2 mt-2 flex-wrap">
              <span class="font-bold text-base">₹{{ getBasePrice() > 0 ? (getBasePrice() | number: "1.2-2") : '0'
                }}</span>
              <span class="line-through text-xs text-gray-400"
                *ngIf="hasDiscount() && getOriginalBasePrice() > getBasePrice()">
                ₹{{ getOriginalBasePrice() > 0 ? (getOriginalBasePrice() | number: "1.2-2") : '0' }}
              </span>
              <span class="bg-emerald-800 text-white text-xs px-2 rounded-full whitespace-nowrap"
                *ngIf="getDiscountPercentage() > 0">
                {{ getDiscountPercentage() }}% Off
              </span>
            </div>
            <div class="text-[13px] leading-5 mt-2 text-gray-700">
              Sold by: <span class="font-bold text-black">{{ getSellerName() }}</span>
            </div>
            <!-- Quantity Display -->
            <div class="text-[13px] leading-5 mt-1 text-[#0A0A5F] font-medium" *ngIf="isScrapPart()">
              Quantity:
              <span class="font-bold">{{ getTotalQuantity() | number: "1.0-2" }} {{ getQuantityUnit() }}</span>
            </div>
          </div>
        </div>

        <!-- Coupon Section -->
        <div class="px-4 sm:px-6 pt-4" *ngIf="availableCoupons && availableCoupons?.length > 0">
          <div class="flex flex-col justify-center p-3 mt-4 w-full font-bold rounded-lg bg-blue-200 bg-opacity-20">
            <div class="flex gap-10 justify-between items-start w-full">
              <div class="flex gap-2 items-start flex-1">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z">
                  </path>
                </svg>
                <div class="flex flex-col justify-center">
                  <h3 class="text-base text-blue-950">Coupons</h3>
                  <p *ngIf="!selectedCoupon" class="mt-1 text-sm leading-none text-emerald-800">
                    {{ availableCoupons?.length || 0 }} Coupons available
                  </p>
                  <p *ngIf="selectedCoupon" class="mt-1 text-sm leading-none text-emerald-800">
                    <span class="font-semibold">{{
                      selectedCoupon.coupon_code
                      }}</span>
                    applied • Save ₹{{ selectedCoupon.savings }}
                  </p>
                </div>
              </div>
              <button type="button"
                class="flex gap-1 justify-center items-center text-base text-center text-blue-500 rounded-xl"
                (click)="openCouponPopup()">
                <span class="gap-2 self-stretch my-auto text-blue-500">{{
                  selectedCoupon ? "Change" : "View All"
                  }}</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Price Details Section -->
        <div class="px-4 sm:px-6 pt-5 pb-4">
          <h3 class="text-base font-bold text-[#0A0A5F] leading-6 mb-3">
            Price Details
          </h3>
          <div class="space-y-2 text-sm leading-6 text-neutral-600">
            <div class="flex justify-between">
              <span>Sub Total</span>
              <span class="font-medium text-neutral-800">₹{{ getBasePrice() > 0 ? (getBasePrice() | number: "1.2-2") :
                '0' }}</span>
            </div>
            <div class="flex justify-between" *ngIf="hasBookingAmount()">
              <span>
                Scrap Booking Amount
                <!-- <span *ngIf="getBookingPercentage()" class="text-xs font-bold text-blue-600 ml-1">
                  ({{ getBookingPercentage() }}%)
                </span> -->
              </span>
              <span class="font-medium text-neutral-800">+ ₹{{ getBookingAmount() > 0 ? (getBookingAmount() | number:
                "1.2-2") : '0' }}</span>
            </div>
            <label *ngIf="hasBookingAmount() || payFullAmount"
              class="flex items-start gap-2 cursor-pointer text-[13px] leading-5 text-neutral-700">
              <input type="checkbox" class="mt-0.5 w-4 h-4 rounded border-gray-300 accent-[#0A0A5F]"
                [(ngModel)]="payFullAmount" (ngModelChange)="onPayFullAmountChange($event)"
                aria-label="Pay full amount now" />
              <span>Pay full amount now instead of booking amount.</span>
            </label>

            <!-- <div *ngIf="hasBookingAmount() && !payFullAmount && getBalanceAmount() > 0"
              class="flex items-start gap-2 mt-2 p-2.5 bg-blue-50/70 rounded-lg border border-blue-100 text-[#0A0A5F]">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"
                class="mt-0.5 shrink-0 text-blue-700">
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path
                  d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
              </svg>
              <p class="text-[#0A0A5F] font-medium text-xs leading-relaxed">
                The balance amount of ₹{{ getBalanceAmount() | number: "1.2-2" }} is to be paid at the time of store
                pickup.
              </p>
            </div> -->

            <div class="flex justify-between">
              <span>Discount On Base Price</span>
              <span class="text-green-600">- ₹{{ getDiscountAmount() }}</span>
            </div>
            <div class="flex justify-between">
              <span>Platform Charges</span>
              <span class="text-gray-900">+ ₹{{ getPlatformCharges() }}</span>
            </div>
            <div class="flex justify-between">
              <span>Delivery Charges</span>
              <span class="text-gray-900">{{ getDeliveryCharges() > 0 ? ('+ ₹' + getDeliveryCharges()) : 'Free'
                }}</span>
            </div>
            <div class="flex justify-between">
              <span>GST</span>
              <span class="text-gray-900">+ ₹{{ getGSTAmount() }}</span>
            </div>
            <div class="flex justify-between">
              <span>TCS</span>
              <span class="text-gray-900">+ ₹{{ getTCSAmount() }}</span>
            </div>
            <div class="flex justify-between">
              <span>Offer Discount</span>
              <span class="text-green-600">- ₹{{ getOfferDiscount() }}</span>
            </div>
          </div>
          <div class="flex justify-between mt-4 pt-3 border-t font-bold text-base text-[#0A0A5F] leading-6">
            <span>Total Amount</span>
            <span>₹{{ getDisplayTotalAmount() }}</span>
          </div>
        </div>
      </div>

      <!-- Payment Button - Fixed Footer -->
      <!-- <div
        *ngIf="paymentErrorMessage"
        class="mx-4 sm:mx-6 mt-3 px-3 py-2 rounded-lg bg-red-50 border border-red-200 text-red-700 text-sm"
      >
        {{ paymentErrorMessage }}
      </div> -->
      <div class="flex justify-between items-center px-4 sm:px-6 py-4 border-t bg-white flex-shrink-0 gap-3">
        <div class="min-w-0">
          <div class="text-[13px] leading-5 text-gray-500">Total Amount</div>
          <div class="font-bold text-lg leading-6 text-[#0A0A5F]">
            ₹{{ getDisplayTotalAmount() }}
          </div>
        </div>
        <div class="flex items-center gap-2 flex-shrink-0">
          <button type="button"
            class="bg-[#0A0A5F] text-white font-bold px-4 sm:px-5 py-2.5 rounded-lg text-sm leading-5 shrink-0 cursor-pointer"
            (click)="onMakeEnquiry()" [disabled]="!canPlaceOrder" [class.opacity-60]="!canPlaceOrder">
            Enquire Now
          </button>
          <button type="button"
            class="bg-[#0A0A5F] text-white font-bold px-4 sm:px-5 py-2.5 rounded-lg text-sm leading-5 shrink-0"
            [disabled]="!canPlaceOrder" [class.opacity-60]="!canPlaceOrder" (click)="onMakePayment()">
            Make Payment
          </button>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Address Selection Popup -->
<div *ngIf="showAddressSelectionPopup" class="fixed inset-0 bg-black bg-opacity-50 z-[90]"
  (click)="closeAddressSelection()"></div>
<div
  class="fixed top-0 right-0 h-full max-md:bottom-0 max-md:top-auto max-md:inset-x-0 max-md:h-auto max-md:max-h-[90vh] z-[91] transition-transform ease-in-out duration-300 transform bg-white shadow-xl w-full sm:w-[90vw] md:w-[400px] max-md:rounded-2xl flex flex-col"
  [ngClass]="
    showAddressSelectionPopup
      ? 'translate-x-0 max-md:translate-x-0 max-md:translate-y-0'
      : 'translate-x-full max-md:translate-x-0 max-md:translate-y-full'
  " *ngIf="showAddressSelectionPopup">
  <!-- Header -->
  <header
    class="flex justify-between items-center px-4 sm:px-6 py-3 sm:py-4 border-b flex-shrink-0 max-md:rounded-t-2xl">
    <h1 class="text-lg sm:text-xl font-bold text-[#0A0A5F] leading-6">
      {{
      addressType === "shipping"
      ? "Select Delivery Address"
      : "Select Billing Address"
      }}
    </h1>
    <button type="button" class="p-0 border-0 bg-transparent" (click)="closeAddressSelection()">
      <svg class="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
  </header>

  <!-- Address List - Scrollable Content -->
  <div class="flex-1 overflow-y-auto p-4 sm:p-6">
    <div class="space-y-3">
      <div *ngFor="let address of addresses" (click)="selectAddress(address.id)">
        <div class="flex items-start gap-3">
          <input type="radio" [checked]="selectedAddressId === address.id" class="w-4 h-4 text-blue-600 mt-1" />
          <div class="flex-1">
            <div class="flex items-center gap-2 flex-wrap">
              <div class="font-semibold text-gray-900">
                {{
                address?.receiver_name ||
                address?.company_name ||
                userData?.first_name + " " + userData?.last_name
                }}
              </div>

              <span class="px-2 py-0.5 text-xs bg-gray-100 border border-gray-300 rounded-full text-gray-700"
                *ngIf="address?.address_type">
                {{ address?.address_type | titlecase }}
              </span>
            </div>
            <div class="text-sm text-gray-700 mt-1">
              {{ formatAddress(address) }}
            </div>
            <div class="text-sm text-gray-500" *ngIf="address?.phone_no">
              Contact: {{ address.phone_no }}
            </div>
          </div>
        </div>
      </div>

      <div class="text-sm text-gray-500" *ngIf="addresses.length === 0">
        No addresses found
      </div>
    </div>
  </div>

  <!-- Footer with buttons - Fixed at bottom -->
  <div class="border-t bg-gray-50 p-4 sm:p-6 flex-shrink-0">
    <div class="flex gap-3">
      <!-- Add Billing Address Button -->
      <button type="button"
        class="flex-1 p-1 border-2 border border-blue-900 rounded-lg text-blue-900 transition-colors bg-white"
        (click)="addNewAddress()">
        <div class="flex items-center justify-center gap-2">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
          </svg>
          <span class="font-medium" *ngIf="addressType === 'shipping'">Add Address</span>
          <span class="font-medium white-space-nowrap" *ngIf="addressType !== 'shipping'">Add Billing Address</span>
        </div>
      </button>

      <!-- Apply Button -->
      <button type="button"
        class="flex-1 bg-blue-950 text-white font-bold py-3 rounded-lg transition-colors hover:bg-blue-900"
        (click)="applyAddressSelection()">
        Apply
      </button>
    </div>
  </div>
</div>

<!-- Address Component -->
<app-address *ngIf="showBillingPopup" (close)="onCloseBillingDetails()" (save)="onSaveAddressDetails($event)"
  [type]="addressType"></app-address>

<!-- GST Component -->
<app-gst *ngIf="showGSTINPopup" (close)="onCloseGSTINPopup()" (save)="onSaveGSTINDetails($event)"></app-gst>

<!-- Coupon Component -->
<app-coupon *ngIf="showCouponPopup" (close)="closeCouponPopup()" (save)="onSaveCouponDetails($event)"
  [availableCoupons]="availableCoupons" [currentSelectedCoupon]="selectedCoupon"></app-coupon>

<!-- Login Modal -->
<!-- <div
  *ngIf="showLoginModal"
  id="authentication-modal"
  class="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50"
  tabindex="-1"
  aria-hidden="true">
  <div class="relative bg-white rounded-lg shadow">
    <button
      class="absolute top-2 right-2 text-gray-500 hover:text-gray-800 login hidden sm:flex"
      (click)="closeLoginPopup()"
      aria-label="Close">
      ✕
    </button>

    <app-login 
      (loginSuccess)="closeLoginPopup()" 
      [productData]="productData"
      [actionType]="currentAction">
    </app-login>
  </div>
</div>  -->